<template>
  <div class="secretary-record">
    <!--实时语音识别-->
    <div class="content" v-show="userType != 3">
      <div class="title">
        湛江仲裁委员会 开庭笔录
      </div>
      <p class="time">上次自动同步时间：{{ time }}  <span class="click" @click="_refresh">刷新</span> </p>
      <div class="info" v-html='content'>
      </div>
    </div>
    <div class="content edit"  v-show="userType === 3">
      <div class="title">
        湛江仲裁委员会 编辑开庭笔录
      </div>
      <p class="time">上次自动同步时间：{{ time }}</p>
      <div class="info" ref="editor">
      </div>
      <div class="btn"><button class="click" @click="_submit">保存</button></div>
    </div>

  </div>
</template>

<script>
import { meCourtRecord, refreshRecord, aiText } from '@/service/getData'
import E from 'wangeditor'
export default {
  data () {
    return {
      id: -1,
      userType: -1,
      content: '',
      time: '',
      editContent: '',
      editor: null,
      iv: null,
      text: ''
    }
  },

  created () {
    this.userType = parseInt(this.$route.query.userType)
    this.id = parseInt(this.$route.query.id)
  },

  mounted () {
    this._refresh()
    if (this.userType === 3 && this.editor === null) {
      this.initEdit()
    }
    this.iv = setInterval(() => {
      this._refresh(false)
      if (this.userType === 3 && this.text !== this.editContent) {
        this._submit()
      }
    }, 10000)
  },

  methods: {
    /**
     * 初始化编辑器
     */
    initEdit () {
      this.editor = new E(this.$refs.editor)
      this.editor.customConfig.menus = [
        'bold',
        'head',
        'fontSize',
        'fontName',
        'italic',
        'underline',
        'strikeThrough',
        'foreColor',
        'backColor',
        'list',
        'justify',
        'undo',
        'redo'
      ]
      this.editor.customConfig.pasteFilterStyle = true
      this.editor.customConfig.onchange = (html) => {
        this.editContent = html
      }
      this.editor.create()
      this.editor.txt.html(this.editContent)
    },

    /**
     * 刷新笔录
     */
    async _refresh (edit = true) {
      if (this.userType === 3) {
        var ai = await aiText(this.id)
        if (ai.code === 1) {
          this.content = ai.data.content
        }
      }
      this.time = this.$util.formatDate(new Date().getTime())
      var record = await meCourtRecord(this.id)
      if (record.code === 1) {
        if (this.userType === 3) {
          if (edit) {
            if (this.editor !== null && this.text !== record.data.content) {
              this.editContent = record.data.content
              this.text = record.data.content
              this.editor.txt.html(this.editContent)
            }
          }
        } else {
          this.content = record.data.content
        }
      }
    },

    /**
     * 提交笔录
     */
    async _submit () {
      var res = await refreshRecord({ meetingId: this.id, content: this.editContent })
      if (res.code !== 1) {
        this.$message.error(res.msg)
      } else {
        this.text = this.editContent
        this.$message.success('保存成功')
      }
    }
  },

  destroyed () {
    clearInterval(this.iv)
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.secretary-record {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include ct;
    background-color: #F0F0F0;
    border-radius: 0.083rem;
    overflow: hidden;
    // right: 0;
    left: 20vw;
    width: 60vw;
    height: 95vh;
    &.edit {
      .info {
        padding: 0;
        box-sizing: border-box;
        height: calc(85vh - 50px) !important;
        .w-e-text-container {
          height: calc(100% - 30px) !important;
        }
        .w-e-toolbar {
          flex-wrap: wrap;
        }
      }
      .btn {
        text-align: center;
        button {
          margin-top: 15px;
          line-height: 30px;
          width: 50px;
          height: 30px;
          background-color: #267CD0;
          color: #fff;
          border-radius: 0.25rem;
          font-size: 0.133rem;
          font-family: PingFang SC;
          font-weight: 500;
        }
      }
    }
    &.r {
      left: 0;
    }
    .info {
      overflow: auto;
      background-color: #fff;
      margin: 0 0.167rem;
      height: 85vh;
      border-radius: 0.083rem;
      padding: 0.15rem;
      font-size: 0.117rem;
      color: #333333;
      white-space: normal;
      word-break: break-all;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background-color: #F5F5F5;
      }
    }
    .time {
      text-align: center;
      font-size: 0.117rem;
      height: 3vh;
      line-height: 3vh;
      color: #666666;
      span {
        color: #3D97E6;
      }
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
    }
    .title {
      height: 6vh;
      line-height: 6vh;
      font-size: 0.15rem;
      font-family:PingFang SC;
      font-weight:bold;
      text-align: center;
      position: relative;
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem)
      }
    }
  }
}
</style>
